import { createTheme } from '@mui/material/styles';

export const themeOptions = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#701280',
            light: '#8E3A9E',
            dark: '#560D6A',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#FF6B35',
            light: '#FF8F65',
            dark: '#CC5020',
            contrastText: '#ffffff',
        },
        background: {
            default: '#FAFAF8',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#1C1C28',
            secondary: '#6B6B7B',
        },
        divider: 'rgba(0,0,0,0.07)',
        success: { main: '#10B981' },
        error: { main: '#EF4444' },
        warning: { main: '#F59E0B' },
        info: { main: '#3B82F6' },
    },
    typography: {
        fontFamily: '"Inter", "Helvetica Neue", "Arial", sans-serif',
        h1: { fontWeight: 800, letterSpacing: '-0.5px' },
        h2: { fontWeight: 700, letterSpacing: '-0.3px' },
        h3: { fontWeight: 700 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    shape: { borderRadius: 12 },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    fontWeight: 600,
                    letterSpacing: '-0.1px',
                    boxShadow: 'none',
                    '&:hover': { boxShadow: 'none' },
                },
                contained: {
                    background: 'linear-gradient(135deg, #701280, #8E3A9E)',
                    '&:hover': {
                        background: 'linear-gradient(135deg, #560D6A, #7A1A90)',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 10,
                        backgroundColor: '#FFFFFF',
                        '& fieldset': { borderColor: 'rgba(0,0,0,0.12)' },
                        '&:hover fieldset': { borderColor: 'rgba(112,18,128,0.3)' },
                        '&.Mui-focused fieldset': { borderColor: '#701280', borderWidth: 1.5 },
                    },
                    '& .MuiInputLabel-root': { color: '#6B6B7B' },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#701280' },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    backgroundColor: '#FFFFFF',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)',
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.07)',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    margin: '2px 4px',
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(112,18,128,0.08)',
                        '&:hover': { backgroundColor: 'rgba(112,18,128,0.12)' },
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: { borderRadius: 8 },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: { borderColor: 'rgba(0,0,0,0.07)' },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#1C1C28',
                    fontSize: '0.75rem',
                    borderRadius: 8,
                },
            },
        },
    },
});
